import { render } from "./HSK2026.vue?vue&type=template&id=ab4c5c7a&scoped=true"
import script from "./HSK2026.vue?vue&type=script&lang=js"
export * from "./HSK2026.vue?vue&type=script&lang=js"

import "./HSK2026.vue?vue&type=style&index=0&id=ab4c5c7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab4c5c7a"]])

export default __exports__